import { createTheme, initializeIcons, ThemeProvider } from '@fluentui/react';
import React from 'react';
import { useAuth } from '../../contexts/authContext';
import LayoutOffline from './LayoutOffline/LayoutOffline';
import LayoutOnline from './LayoutOnline/LayoutOnline';
import MainProgressIndicator from './MainProgressIndicator';

const theme = createTheme({
    defaultFontStyle: { fontFamily: "Acumin Pro" },
    components: {
        PrimaryButton: {
            styles: {
                root: {
                    border: "none",
                    borderRadius: 0,
                    color: "white",
                    fontSize: 18,
                    fontWeight: 700,
                    height: 45,
                    lineHeight: "22px",
                },
            }
        },
    },
    palette: {
        themePrimary: '#ff0000',
        themeLighterAlt: '#fff5f5',
        themeLighter: '#ffd6d6',
        themeLight: '#ffb3b3',
        themeTertiary: '#ff6666',
        themeSecondary: '#ff1f1f',
        themeDarkAlt: '#e60000',
        themeDark: '#c20000',
        themeDarker: '#8f0000',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#595959',
        neutralSecondary: '#373737',
        neutralPrimaryAlt: '#2f2f2f',
        neutralPrimary: '#000000',
        neutralDark: '#151515',
        black: '#0b0b0b',
        white: '#ffffff',
    }
});

initializeIcons();

const Layout = (props) => {

    const { children } = props;

    const { isAuthenticated } = useAuth();
    const idContact = sessionStorage.getItem("idContact");

    return <ThemeProvider style={{ height: "100%" }} theme={theme}>
        <MainProgressIndicator />
        {!!idContact || isAuthenticated
            ? <LayoutOnline>{children}</LayoutOnline>
            : <LayoutOffline />
        }
    </ThemeProvider>;

};

export default Layout;